import React from "react";
import Card from "../../components/page/Card";
import useApi from "../../hooks/useApi";
import CertificadoApiClient from "../../api/certificado";
import ContatoCertificadoModal from "./CertificadoVencer/ContatoCertificadoModal";
import CertificadoVencerDataTable from "./CertificadoVencer/CertificadoVencerDataTable";

function CertificadoVencer() {
  const [certificadosVencer, setCertificadosVencer] = React.useState([]);
  const [contatoCertificadoModal, setContatoCertificadoModal] =
    React.useState(false);
  const [filtroValues, setFiltroValues] = React.useState({
    inicio: null,
    fim: null,
    status: "todos",
  });
  const [values, setValues] = React.useState({});

  const { request: getCertificadosVencer, data: certificadosVencerResponse } =
    useApi(CertificadoApiClient.buscaCertificadosVencer);
  const contatoEmpresaApi = useApi(CertificadoApiClient.getContatoEmpresa);

  //Busca dados dos cards ao renderizar tela
  React.useEffect(() => {
    getCertificadosVencer({
      ...filtroValues,
      status: filtroValues.status === "todos" ? null : filtroValues.status,
    });
  }, [getCertificadosVencer, filtroValues]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (certificadosVencerResponse)
      setCertificadosVencer(certificadosVencerResponse);
  }, [certificadosVencerResponse]);

  const togContatoCertificadoModal = async (uid) => {
    const response = await contatoEmpresaApi.request(uid);
    if (!response) return;
    setValues(response);
    setContatoCertificadoModal(true);
  };

  return (
    <Card>
      <CertificadoVencerDataTable
        certificados={certificadosVencer}
        togNovoContatoCertificadoModal={togContatoCertificadoModal}
        filtroHook={{ filtroValues, setFiltroValues }}
      />
      <ContatoCertificadoModal
        modalHook={{ contatoCertificadoModal, setContatoCertificadoModal }}
        valuesHook={{ values, setValues }}
      />
    </Card>
  );
}

export default CertificadoVencer;
